import ReceptionUnexpectedly from './ReceptionUnexpectedly.jsx';
export {
  ReceptionUnexpectedly
};



// WEBPACK FOOTER //
// ./src/components/modules/reception-unexpectedly/list-reception-unexpectedly/index.js